// extracted by mini-css-extract-plugin
module.exports = {"contentFirstWindow":"idt-giftwindowstackitem_contentfirstwindow__2xrlw"};